<template>
    <div :class="$style.container"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)">
        <navBar :tags="tags" :title="title" :subTitle="subTitle" :btnAgree="btnAgree" :btnRefuse="btnRefuse"
                :btnRepeal="btnRepeal" :btnBack="true"
                @btnAgreeClick="handleApproveClick('APPROVE')" @btnRefuseClick="handleApproveClick('REFUSE')"
                @btnRepealClick="handleApproveClick('AWAIT')" @btnBackClick="handleBackClick"
        />
        <div :class="$style.body">

            <el-row :gutter="20">
                <el-col :span="6">
                    <div style="text-align: right">
                        <h4>申请人</h4>
                        <h4>申请日期</h4>
                        <h4>事由</h4>
                        <h4>审批人</h4>
                        <h4>审批日期</h4>
                        <h4>补签时间</h4>
                        <h4>补签类型</h4>
                        <h4 class="h3">当天班次</h4>
                    </div>
                </el-col>
                <el-col :span="14">
                    <div>
                        <h4><em>{{last_name}}</em></h4>
                        <h4><em>{{created_date}}</em></h4>
                        <h4><em>{{reason}}</em></h4>
                        <h4><em>{{application_name}}</em></h4>
                        <h4><em>{{application_date}}</em></h4>
                        <h4><em>{{checkin_time}}</em></h4>
                        <h4><em>{{checkin_type}}</em></h4>
                        <h4>
                            <span :class="$style.span_shift"
                                  :style="{'background':getBackground(item.original_icon_color)}">{{item.original_icon_text ? item.original_icon_text : '未排班'}}</span>
                            <em v-if="item.original_start_time">{{item.original_start_time}}-{{item.original_end_time}}</em>
                        </h4>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div><img v-show="vShow(status)" :src="stampUrl" width="80px"
                              style="right:10px;bottom:10px" align="right"/></div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
    import navBar from '../../../../components/navBar'
    import http from '../../../../APIService/http'
    import ApprovedUrl from '../../../../assets/images/approved.png'
    import RefusedUrl from '../../../../assets/images/refused.png'
    import moment from 'moment'

    export default {
        data() {
            return {
                loading: false,
                tags: ['考勤', '门店详情'],
                title: '门店',
                subTitle: '补签申请',
                btnAgree: false,
                btnRefuse: false,
                btnRepeal: false,

                item: '',
                last_name: '',
                created_date: '',
                reason: '',
                application_name: '',
                application_date: '',
                checkin_time: '',
                checkin_type: '',
                status: '',

                stampUrl: ApprovedUrl
            }
        },
        components: {
            navBar
        },
        computed: {},
        created() {

            let obj = this.$store.getters.getStore
            this.id = obj.id
            this.title = obj.storeName

            this.item = this.$route.query.row

            if (this.item) {
                this.setItem(this.item)
            } else {
                this.handleBackClick()
            }

        },
        methods: {

            setItem(item) {
                //判断当前登录人是否可以做审批
                let user_id = this.$store.getters.getUser.user_id
                if (user_id !== item.created_by) {
                    if (item.status === 'AWAIT') {
                        this.btnAgree = true
                        this.btnRefuse = true
                    } else if (item.status === 'APPROVE') {
                        // this.btnRepeal = true
                    }
                }
                this.last_name = item.last_name
                this.created_date = moment(item.created_date).format("YYYY-MM-DD HH:mm:ss")
                this.reason = item.reason
                this.application_name = item.approved_by
                if (item.approved_date) {
                    this.application_date = moment(item.approved_date).format("YYYY-MM-DD HH:mm:ss")
                }
                this.checkin_time = item.checkin_time
                this.checkin_type = (item.checkin_type === 'CHECKIN' ? '签入' : '签出')
                this.status = item.status
            },
            vShow(status) {

                switch (status) {
                    case 'AWAIT':
                        return false
                    case 'APPROVE':
                        this.stampUrl = ApprovedUrl
                        return true
                    case 'REFUSE':
                        this.stampUrl = RefusedUrl

                        return true
                    default:
                        return false
                }
            },
            //审批
            async handleApproveClick(status) {
                this.loading = true

                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id: user.tenant_id,
                        application_id: this.item.application_id,
                        approved_result: status,
                        application_type: this.item.application_type,
                        approved_by: user.user_id
                    }

                    await http.post('/wapi/v1/postApproval', data).then(res => {

                        if (res.success) {
                            this.handleBackClick()
                        }

                        this.loading = false


                    })

                } catch (err) {
                    this.loading = false
                    console.log(`error:${err}`)
                }
            },
            // 修改班次的背景色
            getBackground(color) {
                if (color) {
                    return 'rgb(' + color + ')'
                } else {
                    return 'rgb(155,155,155)'
                }

            },
            // 返回按钮
            handleBackClick() {
                this.$router.push({
                    path: '/attendance/retroactiveApply'
                })
            }
        }
    }
</script>
<style lang="scss" module>
    @import '../../../../assets/css/default';

    .container {
        background: #fff;
        padding: 20px 20px;
        height: 100%;
        box-sizing: border-box;
        .body {

            em {
                margin-left: 10px;
                color: #4A90E2;
            }

            .span_shift {
                font-size: 12px;
                color: #FFFFFF;
                border-radius: 3px;
                padding: 4px;
                display: -moz-inline-box;
                display: inline-block;
                text-align: center;
                line-height: 15px;
                width: 40px;
                margin-left: 10px;
            }

        }
    }
</style>
<style scoped>
    h4 {
        margin-top: 40px;
        font-size: 14px;
        color: #000000;
    }

    .h3 {
        margin-top: 44px;
        font-size: 14px;
        color: #000000;
    }

</style>




// WEBPACK FOOTER //
// src/pages/attendance/retroactiveApply/retroactiveInfo/index.vue